import { gql } from '@apollo/client';

const schema = {
  create: {
    name: 'createAttributeValue',
    serviceName: 'admin',
    query: gql`
      mutation createAttributeValue($title: String!, $attribute_id: String!, $details: String) {
        createAttributeValue(title: $title, attribute_id: $attribute_id, details: $details) {
          messages
        }
      }
    `,
  },
};

export default schema;
